module.exports = __webpack_public_path__ + "static/car-abeff0e5c9b6f5eb20d8bd225471c100.jpg";